import React from 'react';
import { useIntl } from 'react-intl';

import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import { Box } from 'carbon-react/lib/components/box/box.component';

export interface DialogWizardSuccessScreenProps {
  text?: string;
}

export const DialogWizardSuccessScreen = ({ text }: DialogWizardSuccessScreenProps) => {
  const intl = useIntl();

  const defaultText = intl.formatMessage({
    id: 'common.success',
    defaultMessage: 'Success'
  });

  return (
    <Box display="flex" flexDirection="column" height="100%" alignItems="center" justifyContent="center">
      <div data-testid="dialog-wizard-success">
        <Typography variant="p" fontWeight="500" textAlign="center" mb={0}>
          <Icon
            type="tick_thick"
            bgSize="extra-large"
            bgShape="circle"
            bg="--colorsActionMajor500"
            color="--colorsUtilityYang100"
            fontSize="large"
            mb={2}
          />
        </Typography>
        <Typography variant="p" fontWeight="500" textAlign="center" mb={0}>
          {text ?? defaultText}
        </Typography>
      </div>
    </Box>
  );
};
